import React from 'react';
import _ from 'lodash';
import DropdownDisplay from '../dropdown-display.jsx';
import DropdownList from '../dropdown-list.jsx';
import OptionButton from '../option-button';
import Option from '../option';
import CollapsibleOption from '../collapsible-option';

export default class ButtonDropdown extends React.Component {
  generateCollapsibleOptions(optionList, changeHandler) {
    return optionList.map((option, index) => {
      if (_.isEmpty(option.subOptions)) {
        return this.generateOptionItem(option, changeHandler, index);
      } else {
        return this.generateCollapsibleOptionItem(option, index);
      }
    });
  }

  generateSubObtions(label, subOptions) {
    return subOptions.map((option, index) => {
      const changeHandler = _.partial(this.props.changeHandler, option.style);
      return this.generateOptionItem(option, changeHandler, index);
    });
  }

  generateOptionList(optionList, changeHandler) {
    return _.map(optionList, (option, index) => {
      return this.generateOptionItem(option, changeHandler, index);
    });
  }

  generateOptionItem(optionData, changeHandler, index) {
    return (
      <Option
        style={optionData.style}
        onClick={changeHandler}
        value={optionData.value}
        selected={optionData.selected}
        key={index}
      >
        {optionData.label}
      </Option>
    );
  }

  generateCollapsibleOptionItem(optionData, index) {
    return (
      <CollapsibleOption
        style={optionData.style}
        value={optionData.value}
        key={index}
        open={optionData.isOpen}
        actionControlIcon={optionData.actionControlIcon}
        actionControl={optionData.actionControl}
        containerClass={optionData.containerClass}
      >
        {this.generateSubObtions(optionData.label, optionData.subOptions)}
      </CollapsibleOption>
    );
  }

  optionButton() {
    if (this.props.open) {
      return (
        <OptionButton
          onClick={this.props.buttonClickHandler}
          className={this.props.buttonClassName}
          wide={this.props.wide}
          openRight={this.props.openRight}
        >{this.props.buttonText}
        </OptionButton>
      );
    }
  }

  render() {
    return (
      <div>
        <DropdownDisplay clickHandler={this.props.toggleDropdown}>
          <span style={this.props.selectedLabelStyle}>{this.props.label}</span>
        </DropdownDisplay>

        <DropdownList
          allowTopScroll={this.props.allowTopScroll}
          open={this.props.open}
          wide={this.props.wide}
          openRight={this.props.openRight}
        >
          {this.generateCollapsibleOptions(this.props.collapsibleOptions, this.props.changeHandler)}
          <div className='dropdown-divider' />
          {this.generateOptionList(this.props.options, this.props.changeHandler)}
        </DropdownList>
        {this.optionButton()}

      </div>
    );
  }
}

ButtonDropdown.propTypes = {
  open: React.PropTypes.bool,
  toggleDropdown: React.PropTypes.func,
  label: React.PropTypes.string,
  selectedLabelStyle: React.PropTypes.object,
  buttonClickHandler: React.PropTypes.func,
  buttonClassName: React.PropTypes.string,
  buttonText: React.PropTypes.string,
  allowTopScroll: React.PropTypes.bool,
  options: React.PropTypes.array,
  collapsibleOptions: React.PropTypes.array,
  changeHandler: React.PropTypes.func,
  wide: React.PropTypes.bool,
  openRight: React.PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-types/button-dropdown.jsx